<template>
  <div class="contragents-filter filters-container">
    <select-filter
      type="contragents"
      field="status"
      label="Статус"
      request="objectInfo/contract_statuses"
      :parse-value="({ name }) => name"
    />
    <sorting-control
      style="margin-left: 32px;"
      type="contragents"
      :values="sortingFields"
    />
  </div>
</template>

<script>
import SelectFilter from './helpers/select-filter'
import SortingControl from './helpers/sorting-control'

const sortingFields = [
  { field: 'name', name: 'Название' }
]

export default {
  components: {
    SelectFilter,
    SortingControl
  },
  data () {
    return {
      sortingFields
    }
  }
}
</script>

<style></style>
